import { all } from 'redux-saga/effects';

import { watchFetchCommon } from './fetch';

export function* commonSaga() {
  yield all([watchFetchCommon()]);
}
